"use client";

import { useState } from "react";
import { buttonClassName, FeedbackPopover, Glyph, Tooltip } from "@/components/desktop/ui";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";
import { XError } from "@/utils/error.utils";
const FEEDBACK_MAX_LENGTH = 2000;
export function FeatureRequestButton() {
  const t = useClientTranslations("search");
  const fileFeedback = api.user.fileProductFeedback.useMutation();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return <Tooltip side="bottom" content={t("featureRequest.link")} tipClassName={cn(isPopoverOpen && "hidden")} data-sentry-element="Tooltip" data-sentry-component="FeatureRequestButton" data-sentry-source-file="FeatureRequestButton.tsx">
            <span className="inline-flex">
                <FeedbackPopover surface="chatBar" onOpenChange={setIsPopoverOpen} maxLength={FEEDBACK_MAX_LENGTH} align="end" triggerClassName={buttonClassName({
        variant: "control",
        size: "icon"
      })} trigger={<Glyph name="lightbulb" className="h-4 w-4" />} copy={{
        link: t("featureRequest.link"),
        title: t("featureRequest.title"),
        placeholder: t("featureRequest.placeholder"),
        footnote: t("featureRequest.footnote"),
        send: t("featureRequest.send"),
        sent: t("featureRequest.sent"),
        failed: t("featureRequest.failed")
      }} onSend={async note => {
        const result = await fileFeedback.mutateAsync({
          surface: "chatBar",
          note
        });
        if (result.status !== "filed") {
          throw new XError({
            message: "featureRequest: note was not filed",
            data: {
              reason: result.reason
            }
          });
        }
      }} data-sentry-element="FeedbackPopover" data-sentry-source-file="FeatureRequestButton.tsx" />
            </span>
        </Tooltip>;
}